export default "__VITE_ASSET__C072wnHq__"